export const DATE_WITH_TIME = 'M/D/Y, LT'
export const DIVIDER_DATE = 'LL'
export const DOB = 'L'
export const MESSAGE_TIME = 'LT'
export const NEWS_DATE = 'LL'
export const PROGRESS_DATE = `dddd, L @ ${MESSAGE_TIME}`
